import type {EditableWidgetComponentProps} from "~/components/reports/widgetSpecific/editableWidgets";
import {
    AreaGraphEditableWidgetComponent,
    ComboChartEditableWidgetComponent,
    DonutChartEditableWidgetComponent,
    GaugeEditableWidgetComponent,
    HorizontalBarGraphEditableWidgetComponent,
    ImageEditableWidgetComponent,
    LineGraphEditableWidgetComponent,
    MultiBarGraphEditableWidgetComponent,
    NumberTileEditableWidgetComponent,
    PieChartEditableWidgetComponent,
    ProgressBarEditableWidgetComponent,
    StackedBarGraphEditableWidgetComponent,
    TableEditableWidgetComponent,
    TextEditableWidgetComponent,
} from "~/components/reports/widgetSpecific/editableWidgets";
import type {ViewWidgetComponentProps} from "~/components/reports/widgetSpecific/viewWidgets";
import {
    AreaGraphViewWidgetComponent,
    ComboChartViewWidgetComponent,
    DonutChartViewWidgetComponent,
    GaugeViewWidgetComponent,
    HorizontalBarGraphViewWidgetComponent,
    ImageViewWidgetComponent,
    LineGraphViewWidgetComponent,
    MultiBarGraphViewWidgetComponent,
    NumberTileViewWidgetComponent,
    PieChartViewWidgetComponent,
    ProgressBarViewWidgetComponent,
    StackedBarGraphViewWidgetComponent,
    TableViewWidgetComponent,
    TextViewWidgetComponent,
} from "~/components/reports/widgetSpecific/viewWidgets";
import {WidgetType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";
import type {EnumDictionary} from "~/typeDefinitions";
import type {StoredWidget} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";

export const widgetTypeToEditableWidgetComponentInternal: EnumDictionary<StoredWidget["type"], React.ComponentType<EditableWidgetComponentProps>> = {
    [WidgetType.multiBarGraph]: MultiBarGraphEditableWidgetComponent,
    [WidgetType.stackedBarGraph]: StackedBarGraphEditableWidgetComponent,
    [WidgetType.horizontalBarGraph]: HorizontalBarGraphEditableWidgetComponent,
    [WidgetType.lineGraph]: LineGraphEditableWidgetComponent,
    [WidgetType.numberTile]: NumberTileEditableWidgetComponent,
    [WidgetType.pieChart]: PieChartEditableWidgetComponent,
    [WidgetType.donutChart]: DonutChartEditableWidgetComponent,
    [WidgetType.text]: TextEditableWidgetComponent,
    [WidgetType.image]: ImageEditableWidgetComponent,
    [WidgetType.table]: TableEditableWidgetComponent,
    [WidgetType.progressBar]: ProgressBarEditableWidgetComponent,
    [WidgetType.gauge]: GaugeEditableWidgetComponent,
    [WidgetType.areaGraph]: AreaGraphEditableWidgetComponent,
    [WidgetType.comboChart]: ComboChartEditableWidgetComponent,
};

export const widgetTypeToViewWidgetComponentInternal: EnumDictionary<StoredWidget["type"], React.ComponentType<ViewWidgetComponentProps>> = {
    [WidgetType.multiBarGraph]: MultiBarGraphViewWidgetComponent,
    [WidgetType.stackedBarGraph]: StackedBarGraphViewWidgetComponent,
    [WidgetType.horizontalBarGraph]: HorizontalBarGraphViewWidgetComponent,
    [WidgetType.lineGraph]: LineGraphViewWidgetComponent,
    [WidgetType.numberTile]: NumberTileViewWidgetComponent,
    [WidgetType.pieChart]: PieChartViewWidgetComponent,
    [WidgetType.donutChart]: DonutChartViewWidgetComponent,
    [WidgetType.text]: TextViewWidgetComponent,
    [WidgetType.image]: ImageViewWidgetComponent,
    [WidgetType.table]: TableViewWidgetComponent,
    [WidgetType.progressBar]: ProgressBarViewWidgetComponent,
    [WidgetType.gauge]: GaugeViewWidgetComponent,
    [WidgetType.areaGraph]: AreaGraphViewWidgetComponent,
    [WidgetType.comboChart]: ComboChartViewWidgetComponent,
};
